export default {
  getCntAccKeyException: state => state.cnt,
  getGridDataAccKeyException: state => state.gridData,
  getSearchParamAccKeyException: state => state.searchParam,
  getProjectListAccKeyException: state => state.projectList,
};



// WEBPACK FOOTER //
// ./src/vuex/accKey/exception/accKeyExceptionGetter.js